module.exports = __webpack_public_path__ + "static/media/checkmark-on-small.ada9e31f.svg";